import { render, staticRenderFns } from "./educatingPeople.vue?vue&type=template&id=887a0150&scoped=true"
import script from "./educatingPeople.vue?vue&type=script&lang=js"
export * from "./educatingPeople.vue?vue&type=script&lang=js"
import style0 from "./educatingPeople.vue?vue&type=style&index=0&id=887a0150&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887a0150",
  null
  
)

export default component.exports